<template>
<v-app class="main">
  <v-app-bar
  app
  fixed
  flat
  height="90"
  class="main"
  >
    <a href="/" style="text-decoration: none;" :class="$vuetify.breakpoint.smAndDown ? '' : 'ml-10'">
      <v-img
        class="img"
        src="@/assets/logo1.png"
        contain
        alt="Logo"
        width="150"/>
    </a>
    <v-spacer></v-spacer>
    <a @click="openDrawer" :class="$vuetify.breakpoint.smAndDown  ? '' : 'mr-10'">
      <feather type="menu" class="white--text"/>
    </a>
    <NavigationBar v-model="drawer" @close="closeDrawer"/>
  </v-app-bar>
  <ToastrContainer />

  <v-main class="bgColour">
    <a
      href="https://api.whatsapp.com/send/?phone=27722459777&text&type=phone_number&app_absent=0"
      target="_blank"
      rel="noopener"
      aria-label="Contact Dash Waste on WhatsApp"
      title="Contact Dash Waste on WhatsApp"
      class="whatsapp_float"
      @click="trackWhatsapp"
    >
      <span class="mdi mdi-whatsapp"></span>
    </a>
    <router-view></router-view>
  </v-main>

  <br><br><br>
  <v-footer
    app
    absolute
    padless
    class="pb-10 bgColour"
    >
    <v-container fluid>
      <v-divider class="primary"></v-divider>
      <v-row class="px-4 footer">
        <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
          <v-col class="main--text mt-12">
            <div :style="$vuetify.breakpoint.smAndDown ? 'display: inline-flex; margin-bottom: 1cm;' : ''">
              <a href="/" style="text-decoration: none;"> <v-img contain width="150" src="@/assets/logo.png" alt="Dash Waste"/> </a>
              <div v-if="$vuetify.breakpoint.smAndDown" class="d-flext">
                <a class="ml-12" href="https://www.facebook.com/wrappwaste" target="_blank" style="text-decoration: none;"><img src="@/assets/facebook.svg" width="35" alt="Dash Waste Facebook"/></a>
                <a href="https://www.instagram.com/dashwaste/" target="_blank" style="text-decoration: none;" class="mx-3"><img src="@/assets/instagram.svg" width="33" alt="Dash Waste Instagram"/></a>
                <a href="https://api.whatsapp.com/send?phone=27722459777" target="_blank" style="text-decoration: none;" @click="trackWhatsapp"><img src="@/assets/whatsapp.svg" width="35" alt="Dash Waste WhatsApp"/></a>
              </div>
            </div>
            <br/><br/>
            <div  v-if="$vuetify.breakpoint.smAndDown" class="text-left">
              <a 
                href="https://www.google.com/maps/place/DASH+WASTE+Waste+Removal+%26+Recycling+Application/@-33.9587972,18.7052759,17z/data=!4m8!3m7!1s0x1dcc4fc8a5a1504d:0x5f44d0cb871644f4!8m2!3d-33.9587972!4d18.7052759!9m1!1b1!16s%2Fg%2F11ry7vbm5l?entry=ttu&g_ep=EgoyMDI1MTEzMC4wIKXMDSoASAFQAw%3D%3D" 
                target="_blank" 
                style="text-decoration: none;"
                >
                <img 
                  style="margin-top: -50px;"
                  src="@/assets/googleReviews.png" width="150" alt="Dash Waste Google reviews"/>
              </a>
            </div>
            <!-- TrustBox widget - Review Collector -->
            <div v-if="$vuetify.breakpoint.smAndDown" class="trustpilot-widget text-left" data-locale="en-US" data-template-id="56278e9abfbbba0bdcd568bc" data-businessunit-id="66a1e6acf462e383527b634e" data-style-height="52px" data-style-width="100%">
                <a href="https://www.trustpilot.com/review/dashwaste.co.za" target="_blank" rel="noopener">Trustpilot</a>
            </div>
            <!-- End TrustBox widget -->
            <br>
            <p>Book waste removal online that is simple, <br v-if="!$vuetify.breakpoint.smAndDown"/> fast, and dependable - since 2007.</p>
          </v-col>
          <v-col class="main--text mt-12" md="2">
            <h3 style="font-family: Avenir1;">Quick Links</h3><br/>
            <router-link 
              class="main--text" 
              style="text-decoration: none;"
              v-for="(link, index) in footerLinks"
              :key="index"
              :to="link.to"
            >
              {{ link.name }} <br/>
            </router-link> 
            <a 
              class="main--text" 
              style="text-decoration: none;" 
              href="https://www.google.com/maps/place/DASH+WASTE+Waste+Removal+%26+Recycling+Application/@-33.9587972,18.7052759,17z/data=!4m8!3m7!1s0x1dcc4fc8a5a1504d:0x5f44d0cb871644f4!8m2!3d-33.9587972!4d18.7052759!9m1!1b1!16s%2Fg%2F11ry7vbm5l?entry=ttu&g_ep=EgoyMDI1MTEzMC4wIKXMDSoASAFQAw%3D%3D" 
              target="_blank"> Customer Reviews
            </a><br/>
            
            <router-link
              v-for="service in services"
              :key="service.slug"
              class="main--text"
              style="text-decoration: none;"
              :to="service.path"
            >
              {{ service.name }}<br/>
            </router-link> 
            <router-link class="main--text" style="text-decoration: none;" to="/driver"> Service Providers</router-link><br/>
          </v-col>
          <v-col class="main--text mt-12" md="2">
            <h3 style="font-family: Avenir1;">Legal</h3><br/>
            <router-link class="main--text" style="text-decoration: none;" to="/tc"> Terms of Use</router-link><br/>
          </v-col>
          <v-col class="main--text mt-12" md="3">
            <h3 style="font-family: Avenir1;">Business Details</h3><br/>
            <p> Head Office: 36 Zinfandal Rd, Blackheath, Cape Town, South Africa
              <br/>Registration Number: 2007/008 563/07 <br/>
              VAT Number: 463 027 9224</p>
          </v-col>
          <v-col class="main--text mt-12" md="2">
            <h3 style="font-family: Avenir1;">A ZEE Group Initiative</h3><br/>
            <a href="https://www.zeegroup.co.za/" target="_blank" style="text-decoration: none;">
              <v-img contain height="150" :width="$vuetify.breakpoint.smAndDown ? '100' : ''" src="@/assets/Zeelogo.png" alt="ZEE Group"/>
            </a>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-divider class="primary" v-if="!$vuetify.breakpoint.smAndDown"></v-divider>
            <br/>
            <v-row>
              <v-col v-if="!$vuetify.breakpoint.smAndDown">
                <a href="https://www.facebook.com/wrappwaste" target="_blank" style="text-decoration: none;"><img src="@/assets/facebook.svg" width="35" alt="Dash Waste Facebook"/></a>
                <a href="https://www.instagram.com/dashwaste/" target="_blank" style="text-decoration: none;" class="mx-3"><img src="@/assets/instagram.svg" width="33" alt="Dash Waste Instagram"/></a>
                <a href="https://api.whatsapp.com/send?phone=27722459777" target="_blank" style="text-decoration: none;" @click="trackWhatsapp"><img src="@/assets/whatsapp.svg" width="35" alt="Dash Waste WhatsApp"/></a>
              </v-col>
              <v-col v-if="!$vuetify.breakpoint.smAndDown">
                <a 
                  href="https://www.google.com/maps/place/DASH+WASTE+Waste+Removal+%26+Recycling+Application/@-33.9587972,18.7052759,17z/data=!4m8!3m7!1s0x1dcc4fc8a5a1504d:0x5f44d0cb871644f4!8m2!3d-33.9587972!4d18.7052759!9m1!1b1!16s%2Fg%2F11ry7vbm5l?entry=ttu&g_ep=EgoyMDI1MTEzMC4wIKXMDSoASAFQAw%3D%3D" 
                  target="_blank" 
                  style="text-decoration: none;"
                  >
                  <img 
                    style="margin-top: -50px;"
                    src="@/assets/googleReviews.png" width="150" alt="Dash Waste Google reviews"/>
                </a>
              </v-col>
              <v-col md="3" v-if="!$vuetify.breakpoint.smAndDown">
                <!-- TrustBox widget - Review Collector -->
                <div class="trustpilot-widget" data-locale="en-US" data-template-id="56278e9abfbbba0bdcd568bc" data-businessunit-id="66a1e6acf462e383527b634e" data-style-height="52px" data-style-width="100%">
                  <a href="https://www.trustpilot.com/review/dashwaste.co.za" target="_blank" rel="noopener">Trustpilot</a>
                </div>
                <!-- End TrustBox widget -->
              </v-col>
                <v-col md="2">
                  <button
                    @click="redirect()"
                    class="primary white--text"
                    style="font-size: 18px; height: 50px; border-radius: 20px; width: 100%;"
                    >
                      Sign Up
                </button>
              </v-col>
              <v-col md="2">
                <button
                  @click="redirectLogin()"
                  class="primary white--text"
                  style="font-size: 18px; height: 50px; border-radius: 20px; width: 100%;"
                  >
                    Client Login
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-row>
    </v-container>
  </v-footer>
</v-app>
</template>

<script>
import ToastrContainer from '@/components/ToastrContainer.vue';
import NavigationBar from '@/components/nav-bar/NavigationBar.vue';
import seoContent from '@/content/seo-content';
import { trackContactClick, trackSignupClick } from '@/utils/analytics';

export default {

components: {
  ToastrContainer,
  NavigationBar
},
  name: 'App',
  data() {
    return {
      drawer: false,
      services: seoContent.services,
      footerLinks: [
        { name: "Home", to:"/" },
        { name: "FAQS", to:"/help" },
        { name: "About", to:"/about" }
      ]
    }
  },
  methods: {
    openDrawer() {
      this.drawer = !this.drawer;
    },
    closeDrawer() {
      this.drawer = false;
    },
    redirect(){
      trackSignupClick('footer_client_signup');
      window.location.href = 'https://app.dashwaste.co.za/signup';
    },
    redirectLogin(){
      window.location.href = 'https://app.dashwaste.co.za/login';
    },
    trackWhatsapp(){
      trackContactClick('whatsapp');
    }
  },
  mounted(){
    scrollTo(0, 0);
  }
}

</script>

<style scoped>
.whatsapp_float {
  position: fixed;
  width: 65px;
  height: 65px;
  bottom: 30px;
  right: 30px;
  background-color: #00AF66;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 42px;
  box-shadow: 2px 2px 3px #999;
  z-index: 100;
}

.bgColour{
  background-image: linear-gradient(to right, white, #D3FAE6);
}
.b1{
  display: none;
}

  .footer{
  font-family: Avenir3;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
}

@media screen and (max-width: 450px){
  .img{
    max-width: 125px;
  }
  .b1{
    display: block;
  }
  .b2, .b3{
    display: none;
  }

}
</style>
